import { Grid, Typography } from "@mui/material";
import React from "react";
import StackedHorizontalBarChart from "src/sections/@dashboard/app/StackedHorizontalBarChart";
import { getDuplicateStats } from "src/services/declutter.service";

export default class EnvironmentalImpact extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            by: 'energy',
            total_files_count: 0,
            total_files_size: 0,
            total_duplicates_count: 0,
            total_duplicates_size: 0,
            delete_success_count: 0,
            delete_success_size: 0,
            by_energy: [],
            by_water: [],
        };

    }

    componentDidMount() {
        this.setDuplicateStats();
    }

    async setDuplicateStats() {
    
        let duplicate_stats = await getDuplicateStats();
        if (duplicate_stats.error) {
            console.error(duplicate_stats.error);
            return;
        }
        duplicate_stats = duplicate_stats.duplicate_stats;

        let stats = duplicate_stats.stats || {};
        let total_duplicates_count = duplicate_stats.total_duplicates_count || 0;
        let total_duplicates_size = duplicate_stats.total_duplicates_size || 0;
        let total_files_count = duplicate_stats.total_files_count || 0;
        let total_files_size = duplicate_stats.total_files_size || 0;
        let delete_success_count = duplicate_stats.delete_success_count || 0;
        let delete_success_size = duplicate_stats.delete_success_size || 0;

        this.setState({
            stats,
            total_duplicates_count,
            total_duplicates_size,
            total_files_count,
            total_files_size,
            delete_success_count,
            delete_success_size
        });
        
        let by_energy = [
            {
                name: 'Unique',
                data: [((total_files_size - total_duplicates_size) * 5 / (1024 * 1024 * 1024))],
                color: '#94cd81',
                stack: 'Energy Impact',
                label: 'Unique file energy impact ( in kWh per year )'
            },
            {
                name: 'Duplicate',
                data: [(total_duplicates_size * 5 / (1024 * 1024 * 1024))],
                color: '#f05023',
                stack: 'Energy Impact',
                label: 'Duplicate file energy impact ( in kWh per year )'
            }
        ]

        let by_water = [
            {
                name: 'Unique',
                data: [((total_files_size - total_duplicates_size) * 5 / (1024 * 1024 * 1024))],
                color: '#94cd81',
                stack: 'Water Impact',
                label: 'Unique file water impact ( in litres per year )'
            },
            {
                name: 'Duplicate',
                data: [(total_duplicates_size * 5 / (1024 * 1024 * 1024))],
                color: '#f05023',
                stack: 'Water Impact',
                label: 'Duplicate file water impact ( in litres per year )'
            }
        ]

            
        this.setState({
            by_energy,
            by_water
        });
    }

    render() {
        return (
            <Grid container spacing={2}>

                <Grid item xs={12}>
                    <Typography variant="h5" fontWeight={400} color={'gray'}>
                        Environmental Impact
                    </Typography>
                    <Typography variant="body2" color={'gray'}>
                        Duplicates consume additional storage space, which can lead to increased energy consumption and carbon emissions from data centers. By reducing duplicates, you can contribute to a more sustainable digital environment.
                    </Typography>
                    <Typography variant="body2" color={'gray'}>
                        Storage : ~5kWh per GB per year (varies based on storage type and usage)
                    </Typography>
                    <Typography variant="body2" color={'gray'}>
                        Energy : ~5 litres of water per GB per year (varies based on storage type and usage)
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <StackedHorizontalBarChart
                        series={this.props.by === 'energy' ? this.state.by_energy : this.state.by_water}
                        labels={[this.props.by === 'energy' ? 'Energy (kWh per year)' : 'Water (litres per year)']}
                        value_type={'count'}
                    />
                </Grid>
            </Grid>
        );
    }
}
